import { graphql } from 'react-relay/legacy.js';

export const creatorsRoot = graphql`
    query creatorsRootQuery(
        $nationality: String
        $style: String
        $vertical: VerticalType!
        $hasCreatorsAttribute: Boolean!
    ) {
        viewer {
            ...CreatorsWrapper_viewer
            ...formatCreatorsAttribute_viewer @include(if: $hasCreatorsAttribute)
        }
    }
`;
